<template>
    <PerfectScrollbar class="AllPwaMobile">
        <header-menu></header-menu>

        <div style="direction: rtl;" class="HeaderMenuSixBar">

          <div @click="GiftClass" class="ChildHeaderMenuSixBar">
            <div class="IconChildHeaderMenuSixBar">
              <VsxIcon iconName="Ticket" :size="32" :color="color" type="linear" />
            </div>
            <span>
              {{ $t('profile.discountCoupon') }}
            </span>
          </div>

          <router-link to="/gift" class="nav-item">
            <div class="ChildHeaderMenuSixBar">
              <div class="IconChildHeaderMenuSixBar">
                <VsxIcon iconName="Profile2User" :size="32" :color="color" type="linear" />
              </div>
              <span>{{ $t('profile.inviteToEarn') }}</span>
            </div>
          </router-link>

          <div @click="TableClass" class="ChildHeaderMenuSixBar">
            <div class="IconChildHeaderMenuSixBar">
              <VsxIcon iconName="Add" :size="35" :color="color" type="linear" />
            </div>
            <span>
              <span>{{ getVisibleLevelLabel() }}</span>
              <span>
                : {{ $t('profile.userLevel') }}
              </span>
            </span>
          </div>

          <router-link v-if="CheckIF" to="/verify" class="nav-item">
            <div class="ChildHeaderMenuSixBar">
              <div class="IconChildHeaderMenuSixBar">
                <VsxIcon iconName="SecurityUser" :size="32" :color="color" type="linear" />
              </div>
              <span>{{ $t('profile.verification') }}</span>
            </div>
          </router-link>

          <div @click="checkClick" v-if="!CheckIF" class="ChildHeaderMenuSixBar">
            <div class="IconChildHeaderMenuSixBar">
              <VsxIcon iconName="SecurityUser" :size="32" :color="color" type="linear" />
            </div>
            <span>{{ $t('profile.verification') }}</span>
          </div>


          <router-link to="/wallet-user">
            <div class="ChildHeaderMenuSixBar">
              <div class="IconChildHeaderMenuSixBar">
                <VsxIcon iconName="EmptyWalletChange" :size="32" :color="color" type="linear" />
              </div>
              <span>{{ $t('profile.walletManagement') }}</span>
            </div>
          </router-link>

          <router-link to="/wallet-user">
            <div class="ChildHeaderMenuSixBar">
              <div class="IconChildHeaderMenuSixBar">
                <VsxIcon iconName="Bank" :size="32" :color="color" type="linear" />
              </div>
              <span>{{ $t('profile.bankAccountManagement') }}</span>
            </div>
          </router-link>

          <router-link to="/my-investments" class="nav-item">
            <div class="ChildHeaderMenuSixBar">
              <div class="IconChildHeaderMenuSixBar">
                <VsxIcon iconName="Chart" :size="32" :color="color" type="linear" />
              </div>
              <span>{{ $t('investments.myInvestments') }}</span>
            </div>
          </router-link>

          <router-link to="/contracts" class="nav-item">
            <div class="ChildHeaderMenuSixBar">
              <div class="IconChildHeaderMenuSixBar">
                <VsxIcon iconName="DocumentText" :size="32" :color="color" type="linear" />
              </div>
              <span>{{ $t('investments.contractsTitle') }}</span>
            </div>
          </router-link>
        </div>

        <section class="referral-members" aria-labelledby="referral-members-title">
          <div class="referral-members-heading">
            <h2 id="referral-members-title">{{ $t('profile.referrals.title') }}</h2>
            <span class="referral-members-count">{{ referralUsers.length }}</span>
          </div>

          <p v-if="referralUsersLoading" class="referral-members-state">
            {{ $t('common.loading') }}
          </p>
          <p v-else-if="!referralUsers.length" class="referral-members-state">
            {{ $t('profile.referrals.empty') }}
          </p>

          <ul v-else class="referral-members-list">
            <li v-for="referral in referralUsers" :key="referral.id" class="referral-member">
              <img
                class="referral-member-avatar"
                :src="referral.image || require('../assets/man/userHome.jpg')"
                :alt="referralDisplayName(referral)"
              />
              <div class="referral-member-details">
                <strong>{{ referralDisplayName(referral) }}</strong>
                <span v-if="referral.username">@{{ referral.username }}</span>
              </div>
              <time v-if="referral.joined_at" class="referral-member-date" :datetime="referral.joined_at">
                {{ $t('profile.referrals.joinedAt') }}: {{ formatReferralJoinDate(referral.joined_at) }}
              </time>
            </li>
          </ul>
        </section>

        <div class="ListUserPodileTOUs">
          <div class="ListUserPodileTOUsAvatar">
            <div>
              <p>{{userGet.firstname}} {{userGet.lastname}}</p>
      
            </div>
            <img class="ShowButtonGet" v-if="userGet.image != null" :src="userGet.image"/>
            <img class="ShowButtonGet" v-if="userGet.image == null" src="../assets/man/userHome.jpg"/>
          </div>

          <div class="ListUserPodileTOUsFull">
            <div class="ChildListUserPodileTOUsFull">
              <div class="TitleShowUs">
                {{ $t('profile.username') }}
              </div>
              {{userGet.username}}
            </div>
            <div class="ChildListUserPodileTOUsFull">
              <div class="TitleShowUs">
                {{ $t('profile.mobileNumber') }}
              </div>
              {{userGet.mobile}}
            </div>
          </div>
          <div class="ListUserPodileTOUsFull1">
            <div class="ChildListUserPodileTOUsFull">
              <div class="TitleShowUs">
                {{ $t('profile.email') }}
              </div>
              {{userGet.email}}
            </div>
            <div class="ChildListUserPodileTOUsFull">
              <div class="TitleShowUs">
                {{ $t('profile.referralCode') }}
              </div>
              {{userGet.username}}
            </div>
          </div>

          <!-- Verification Status Section -->
          <div class="ListUserPodileTOUsFull" v-if="userGet.kv">
            <div class="ChildListUserPodileTOUsFull">
              <div class="TitleShowUs">
                وضعیت احرازهویت
              </div>
              <div class="verification-status" :class="getVerificationStatusClass(userGet.kv)">
                <VsxIcon :iconName="getVerificationStatusIcon(userGet.kv)" :size="20" type="bold" />
                <span>{{ getVerificationStatusText(userGet.kv) }}</span>
              </div>
            </div>
          </div>

          <router-link to="/edit-user">
            <div class="EditIconTapLeft">
              <VsxIcon iconName="UserEdit" :size="25" :color="color" type="linear" />
            </div>
          </router-link>

          <div @click="handleLogout" class="LogoutIconTapLeft">
            <VsxIcon iconName="LogoutCurve" :size="25" :color="color" type="linear" />
          </div>
        </div>

        <div @click="showGift = false" v-if="showGift" class="ModelShowIconToUserSpan coupon-list-overlay">
          <div @click.stop class="coupon-list-panel" role="dialog" aria-modal="true" :aria-label="$t('profile.discountCoupon')">
            <div class="coupon-list-heading">
              <h2>{{ $t('profile.discountCoupon') }}</h2>
              <button type="button" class="coupon-list-close" :aria-label="$t('profile.coupon.close')" @click="showGift = false">×</button>
            </div>

            <p v-if="couponLoading" class="coupon-list-message">{{ $t('common.loading') }}</p>
            <p v-else-if="!userDiscounts.length" class="coupon-list-message">{{ $t('profile.coupon.noCoupon') }}</p>

            <div v-else class="coupon-list">
              <div v-for="discount in userDiscounts" :key="discount.id || discount.code" class="coupon">
                <div class="left">
                  <div>{{ $t('profile.coupon.enjoyDiscount') }}</div>
                </div>
                <div class="center">
                  <div>
                    <h2>
                      <span style="font-size: 1.5rem;">{{ formatCouponAmount(discount.amount) }} {{ discount.currency }}</span>
                    </h2>
                    <h3>{{ discount.code }}</h3>
                    <div class="copyCopen" role="button" tabindex="0" @click="copyDiscountCode(discount)" @keydown.enter="copyDiscountCode(discount)" @keydown.space.prevent="copyDiscountCode(discount)">
                      {{ $t('profile.coupon.copyCode') }}
                    </div>
                    <small v-if="discount.expires_at" class="coupon-expiry">
                      {{ $t('profile.coupon.expiresAt') }}: {{ formatCouponExpiry(discount.expires_at) }}
                    </small>
                  </div>
                </div>

                <div class="right">
                  <div>dadepardazan</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div @click="showTable = false" v-if="showTable" class="ModelShowIconToUserSpan">
          <div @click.stop class="TableModelShowIconToUserSpan referral-level-table">
            <div class="TopShiwRowModel">
              <div class="ChildTopShiwRowModel">{{ $t('profile.vipLevels.level') }}</div>
              <div class="ChildTopShiwRowModel">{{ $t('profile.vipLevels.inviteCount') }}</div>
              <div class="ChildTopShiwRowModel">{{ $t('profile.vipLevels.referralReward') }}</div>
              <div class="ChildTopShiwRowModel">{{ $t('profile.vipLevels.withdrawalFee') }}</div>
            </div>

            <p v-if="referralLevelsLoading" class="referral-level-table-message">
              {{ $t('common.loading') }}
            </p>
            <p v-else-if="!referralLevels.length" class="referral-level-table-message">
              {{ $t('profile.vipLevels.empty') }}
            </p>

            <div
              v-else
              v-for="(level, index) in referralLevels"
              :key="`${level.level}-${index}`"
              class="TopShiwRowModel"
              :style="getReferralLevelRowStyle(level)"
            >
              <div class="ChildTopShiwRowModel1">{{ level.level }}</div>
              <div class="ChildTopShiwRowModel1">{{ level.invite_count }}</div>
              <div class="ChildTopShiwRowModel1">{{ formatReferralPercent(level.referral_reward) }}%</div>
              <div class="ChildTopShiwRowModel1">{{ formatReferralPercent(level.withdrawal_fee) }}%</div>
            </div>
          </div>
        </div>

        <menu-bar></menu-bar>
    </PerfectScrollbar>
</template>
  
  
<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import {toast} from "vue3-toastify";
import axios from "@/axios";

  export default {
    name: 'profileUser',
    components: {
      PerfectScrollbar,
    },
    data() {
      return{
        CheckIF: false,
        levelUser: '',
        color: localStorage.getItem('theme') === 'dark' ? '#BB86FC' : '#2E1977',
        showGift: false,
        showTable: false,
        userGet: {},
        referralLevels: [],
        referralLevelsLoading: false,
        currentReferralLevel: null,
        referralUsers: [],
        referralUsersLoading: false,
        userDiscounts: [],
        couponLoading: false,
      };
    },
    methods: {
      async fetchUserDiscount() {
        if (!this.userGet || !this.userGet.id) return;

        this.couponLoading = true;
        try {
          const response = await axios.post('/get-user-latest-discount', {
            user_id: this.userGet.id
          });
          const responseData = response.data || {};
          this.userDiscounts = Array.isArray(responseData.discounts)
            ? responseData.discounts
            : (responseData.discount ? [responseData.discount] : []);
        } catch (error) {
          console.error('Error fetching discount:', error);
          this.userDiscounts = [];
        } finally {
          this.couponLoading = false;
        }
      },

      formatCouponExpiry(expirationDate) {
        if (!expirationDate) return '';
        return new Date(expirationDate).toLocaleDateString(this.$i18n.locale === 'fa' ? 'fa-IR' : 'en-US');
      },

      formatCouponAmount(amount) {
        const value = Number(amount);
        if (!Number.isFinite(value)) return amount ?? '0';
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: 8 }).format(value);
      },

      copyDiscountCode(discount) {
        if (!discount || !discount.code) {
          toast(this.$t('profile.coupon.noCoupon'), {
            autoClose: 3000,
            position: "top-right",
            type: "warning",
          });
          return;
        }
        
        const textToCopy = discount.code;
        
        navigator.clipboard.writeText(textToCopy)
          .then(() => {
            toast(this.$t('profile.coupon.copied'), {
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });
          })
          .catch(err => {
            console.error('Failed to copy code:', err);
            // Fallback method for older browsers
            const tempInput = document.createElement('input');
            tempInput.value = textToCopy;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            
            toast(this.$t('profile.coupon.copied'), {
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });
          });
      },

      checkClick(){
        if(this.userGet.kv == '2'){
          toast(this.$t('profile.verificationStatus.pending'), {
            autoClose: 3000,
            position: "top-right",
            type: "warning",
          });
        }

        if(this.userGet.kv == '1'){
          toast(this.$t('profile.verificationStatus.verified'), {
            autoClose: 3000,
            position: "top-right",
            type: "success",
          });
        }

        if(this.userGet.kv == '3'){
          toast(this.$t('profile.verificationStatus.rejected'), {
            autoClose: 5000,
            position: "top-right",
            type: "error",
          });
        }
      },

      GiftClass(){
        if (!this.couponLoading && !this.userDiscounts.length) {
          toast(this.$t('profile.coupon.noCoupon'), {
            autoClose: 3000,
            position: "top-right",
            type: "warning",
          });
          return;
        }
        this.showGift = true;
      },

      TableClass(){
        this.showTable =! this.showTable
      },
      async fetchReferralLevels() {
        this.referralLevelsLoading = true;
        try {
          const response = await axios.get('/settings/public');
          const rawLevels = response.data?.data?.referral_levels;
          const levels = typeof rawLevels === 'string' ? JSON.parse(rawLevels) : rawLevels;
          this.referralLevels = Array.isArray(levels) ? levels : [];
        } catch (error) {
          console.error('Error fetching referral levels:', error);
          this.referralLevels = [];
        } finally {
          this.referralLevelsLoading = false;
        }
      },
      formatReferralPercent(value) {
        const percentage = Number(value);
        return Number.isFinite(percentage) ? percentage : 0;
      },
      isCurrentReferralLevel(level) {
        const currentLevel = this.getVisibleLevelLabel();
        return Boolean(level?.level) && String(level.level) === String(currentLevel);
      },
      getReferralLevelRowStyle(level) {
        if (!this.isCurrentReferralLevel(level)) {
          return {};
        }

        return {
          background: 'rgba(255, 105, 180, 0.12)'
        };
      },
      getVisibleLevelLabel() {
        const levels = [...this.referralLevels]
          .filter(level => level?.level && Number.isInteger(Number(level?.invite_count)) && Number(level.invite_count) >= 0)
          .sort((a, b) => Number(a.invite_count) - Number(b.invite_count));
        const referralCount = Number(this.referralUsers?.length ?? this.userGet?.referral_count ?? 0);
        const eligibleLevel = levels
          .filter(level => Number(level.invite_count) <= referralCount)
          .pop();

        return this.currentReferralLevel?.level || eligibleLevel?.level || '';
      },
      async fetchReferralUsers(userId) {
        if (!userId) return;

        this.referralUsersLoading = true;
        try {
          const response = await axios.post('/referral-user-get', { id: userId });
          const users = response.data?.referred_users;
          this.referralUsers = Array.isArray(users) ? users : [];
          this.currentReferralLevel = response.data?.current_level || null;
        } catch (error) {
          console.error('Error fetching referred users:', error);
          this.referralUsers = [];
        } finally {
          this.referralUsersLoading = false;
        }
      },
      referralDisplayName(referral) {
        const fullName = [referral.firstname, referral.lastname].filter(Boolean).join(' ').trim();
        return fullName || referral.username || this.$t('profile.referrals.unknownUser');
      },
      formatReferralJoinDate(date) {
        return new Date(date).toLocaleDateString(this.$i18n.locale === 'fa' ? 'fa-IR' : 'en-US');
      },
      loadTheme() {
        const savedTheme = localStorage.getItem('theme');
        if( savedTheme == "light"){
          this.color = '#2E1977'
        }else{
          this.color = '#BB86FC'
        }
      },
      async handleLogout() {
        const result = await this.$swal({
            title: this.$t('logout.confirmTitle'),
            text: this.$t('logout.confirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('logout.confirmButton'),
            cancelButtonText: this.$t('logout.cancelButton')
        });

        if (result.isConfirmed) {
            localStorage.clear();
            this.$router.push('/login');
            toast(this.$t('logout.success'), {
                autoClose: 3000,
                position: "top-right",
                type: "success",
            });
        }
      },

      getVerificationStatusIcon(status) {
        switch(status) {
          case '0': return 'ShieldX';
          case '1': return 'ShieldTick';
          case '2': return 'ShieldSearch';
          case '3': return 'ShieldCross';
          default: return 'Shield';
        }
      },

      getVerificationStatusClass(status) {
        switch(status) {
          case '0': return 'status-not-verified';
          case '1': return 'status-verified';
          case '2': return 'status-pending';
          case '3': return 'status-rejected';
          default: return 'status-unknown';
        }
      },

      getVerificationStatusText(status) {
        switch(status) {
          case '0': return 'احرازهویت نشده';
          case '1': return 'تایید شده';
          case '2': return 'در حال بررسی';
          case '3': return 'رد شده';
          default: return 'نامشخص';
        }
      },

      async fetchUserProfile() {
        const userData = localStorage.getItem('user');
        if (!userData) return;

        const user = JSON.parse(userData);

        try {
          const response = await axios.post('/get-user-profile', {
            user_id: user.id
          });

          if (response.data.success) {
            this.userGet = response.data.user;
            // Update localStorage with fresh data
            localStorage.setItem('user', JSON.stringify(this.userGet));
          }
        } catch (error) {
          console.error('Error fetching user profile:', error);
          // Fallback to localStorage if API fails
          this.userGet = user;
        }
      }
    },
    mounted(){
      const level = localStorage.getItem('level');
      const userData = localStorage.getItem('user');
      if (userData) {
        this.userGet = JSON.parse(userData);
        this.levelUser = JSON.parse(level);
      }

      if(this.userGet.kv == '0' || this.userGet.kv == '3'){
        this.CheckIF = true
      }

      this.loadTheme();

      setInterval(() => {
        this.loadTheme()
      }, 100);

      this.fetchUserDiscount();
      this.fetchReferralLevels();
      this.fetchReferralUsers(this.userGet.id);
      this.fetchUserProfile(); // Fetch fresh user data
    }
  }
</script>
  
<style scoped>
.referral-level-table .TopShiwRowModel {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.referral-level-table-message {
  margin: 0;
  padding: 18px 12px;
  color: var(--text-color, #fff);
  text-align: center;
}

.referral-members {
  margin: 18px 16px 0 16px;
  padding: 18px;
  border: 1px solid var(--surface-border, #ded8eb);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  color: var(--text-color, #201b2b);
}

.referral-members-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.referral-members-heading h2 {
  margin: 0;
  font-size: 1.05rem;
}

.referral-members-count {
  display: inline-flex;
  min-width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
  border-radius: 99px;
  background: rgba(187, 134, 252, 0.16);
  color: var(--primary-color, #6f42c1);
  font-weight: 700;
}

.referral-members-state {
  margin: 0;
  padding: 16px 8px;
  color: var(--text-secondary, #696273);
  text-align: center;
}

.referral-members-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.referral-member {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 10px 0;
  border-top: 1px solid var(--surface-border, #ded8eb);
}

.referral-member-avatar {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 50%;
  object-fit: cover;
}

.referral-member-details {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.referral-member-details strong,
.referral-member-details span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.referral-member-details span,
.referral-member-date {
  color: var(--text-secondary, #696273);
  font-size: 0.85rem;
}

.referral-member-date {
  flex: 0 0 auto;
}

.LogoutIconTapLeft {
  position: absolute;
  left: 60px;
  top: 33px;
  height: 35px;
  width: 40px;
  background: #f5f5f5;
  border-radius: 5px;
  text-align: center;
  padding-top: 3.5px;
  cursor: pointer;
}

.coupon-list-overlay {
  width: 100vw !important;
  padding: 16px;
  box-sizing: border-box;
}

.coupon-list-panel {
  width: min(100%, 560px);
  max-height: min(84vh, 760px);
  overflow-y: auto;
  padding: 20px;
  border: 1px solid var(--surface-border, #ded8eb);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  color: var(--text-color, #201b2b);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.24);
}

.coupon-list-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.coupon-list-heading h2 {
  margin: 0;
  font-size: 1.2rem;
}

.coupon-list-close {
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 8px;
  background: var(--surface-hover, #f1edf8);
  color: inherit;
  font-size: 1.5rem;
  cursor: pointer;
}

.coupon-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.coupon-list-panel .coupon {
  width: min(350px, 100%);
  margin: 0 auto;
}

.coupon-list-message {
  margin: 0;
  padding: 24px 12px;
  text-align: center;
}

.coupon-expiry {
  display: block;
  margin-top: 6px;
  color: #fff;
  text-align: center;
}

.coupon-list-panel .copyCopen:focus-visible,
.coupon-list-close:focus-visible {
  outline: 3px solid #bb86fc;
  outline-offset: 3px;
}

.LogoutIconTapLeft:hover {
    transform: scale(1.1);
    background: var(--surface-hover);
}

.EditIconTapLeft {
    position: absolute;
    left: 20px;
    top: 20px;
    cursor: pointer;
    background: var(--surface-card);
    padding: 8px;
    border-radius: 8px;
    transition: all 0.3s ease;
}

.EditIconTapLeft:hover {
    transform: scale(1.1);
    background: var(--surface-hover);
}

/* Verification Status Styles */
.verification-status {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
}

.verification-status span {
    margin-right: 5px;
}

.status-not-verified {
    background-color: #fee2e2;
    color: #dc2626;
    border: 1px solid #fecaca;
}

.status-verified {
    background-color: #d1fae5;
    color: #059669;
    border: 1px solid #a7f3d0;
}

.status-pending {
    background-color: #fef3c7;
    color: #d97706;
    border: 1px solid #fde68a;
}

.status-rejected {
    background-color: #fee2e2;
    color: #dc2626;
    border: 1px solid #fecaca;
}

.status-unknown {
  background-color: #f3f4f6;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

@media (max-width: 480px) {
  .referral-members {
    margin-right: 10px;
    margin-left: 10px;
    padding: 14px;
  }

  .referral-member {
    gap: 8px;
  }

  .referral-member-avatar {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }

  .referral-member-date {
    font-size: 0.75rem;
  }
}

</style>
  